import type { HTMLAttributes } from "react";

import { useI18n } from "../use-i18n";
import { cn } from "../utils";
import { NcBadge } from "./nc-badge";

interface NcFormattedAddressProps extends HTMLAttributes<HTMLDivElement> {
  label?: string;
  address: {
    street1?: string;
    street2?: string;
    suburb?: string;
    city?: string;
    region?: string;
    postcode?: string;
    country?: string;
    isPrimaryMailing?: boolean;
  };
}

export const NcFormattedAddress = ({
  address,
  label,
  className,
  ...props
}: NcFormattedAddressProps) => {
  const { t } = useI18n();
  return (
    <address
      data-nc="NcFormattedAddress"
      className={cn("flex flex-col gap-0.5 not-italic", className)}
      {...props}
    >
      <div className="flex flex-wrap items-center gap-4">
        {label && <strong className="mb-0.5">{label}</strong>}
        {address.isPrimaryMailing && <NcBadge className="ml-auto">{t("Primary mailing")}</NcBadge>}
      </div>
      {address.street1 && <div>{address.street1}</div>}
      {address.street2 && <div>{address.street2}</div>}
      {address.suburb && <div>{address.suburb}</div>}
      {(address.city || address.postcode) && (
        <div>
          <span>{address.city}</span>
          &nbsp;
          <span>{address.postcode}</span>
        </div>
      )}
      {address.country && <div>{address.country}</div>}
    </address>
  );
};
